import { resolveImagemUrl } from '@/utils/imagemUrl';

export default {
  namespaced: true,
  state: () => ({
    familiasComerciais: [],
    formFamiliaComercial: {
      familia_comercial_id: null,
      familia_comercial_descricao: null,
      familia_comercial_un: null,
    },
    filters: {
      page: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: null,
      total: 0,
    },
    produtosDestaque: [],
  }),
  mutations: {
    setProdutosDestaque(state, payload) {
      state.produtosDestaque = payload.map((i) => ({
        ...i,
        familia_comercial_id: i.familia_comercial_id,
        familia_comercial_descricao: i.familia_comercial_descricao,
        cod_categ: i.cod_categ,
        desc_intern: i.desc_intern,
        cod_marca: i.cod_marca,
        des_marca: i.des_marca,
        Descricao: i.Descricao,
        caminho: resolveImagemUrl(i.caminho),
      }));
    },
    setFamiliasComerciais(state, payload) {
      state.familiasComerciais = payload;
    },
    setFilters(state, payload) {
      state.filters = payload;
    },
  },
  getters: {
    getFamiliasComerciais(state) {
      return state.esMarcas;
    },
    getFilters(state) {
      return state.filters;
    },
    getProdutosDestaque(state) {
      return state.produtosDestaque;
    },
  },
};
